"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
exports.embraceTokenizeVariables = function (originalEmbraceCharacters) { return function (newEmbraceCharacters) { return function (html) {
    return ramda_1.replace(new RegExp("\\" + originalEmbraceCharacters.prefix + "\\s*(variables\\.[a-zA-Z]+)\\s*\\" + originalEmbraceCharacters.suffix, 'g'), newEmbraceCharacters.prefix + "$1" + newEmbraceCharacters.suffix, html);
}; }; };
//# sourceMappingURL=emprace-tokenize-variables.js.map